var originalUrl = window.location.href; 

$('body').on('click', '.quick-add-bulk-popup-wrapper', function(e) {
    e.preventDefault();
    var cstm_url = $(this).closest('li').attr('data-product-url');

    if (!cstm_url) {
        console.error('Custom URL is missing or invalid.');
        return;
    }
    $('.featured-collection-loader-wrapper').css('display', 'flex');
    $('body').addClass('quick-view-active');
$('.featured-collection-data-popup-wrapper svg.icon.icon-close').hide();
$.ajax({
    url: cstm_url,
    type: 'GET',
    dataType: 'html',
    success: function(data) {
        var productHtml = $(data).find('.product-main-wrapper');

        if (productHtml.length) {
            var productInfo = productHtml.find('product-info');
            if (productInfo.attr('data-update-url') === "true") {
                productInfo.attr('data-update-url', "false");
            }

            $('.featured-collection-data-popup-wrapper').css('display', 'block');

            $('.featured-collection-data-popup').html(productHtml.html());

            $('.featured-collection-loader-wrapper').css('display', 'none');
           setTimeout(function () {
          $('.featured-collection-data-popup-wrapper svg.icon.icon-close').show();
              }, 1000);
        } else {
            console.error('Product main wrapper not found in the response.');
        }
    },
    error: function(jqXHR, textStatus, errorThrown) {
        console.error('AJAX error:', textStatus, errorThrown);
    }
});
document.addEventListener("click", function (event) {
    if (event.target.closest(".featured-collection-data-popup-wrapper svg.icon.icon-close")) {
      
        let popupWrapper = document.querySelector(".featured-collection-data-popup-wrapper");
        if (popupWrapper) {
            popupWrapper.classList.add("active");
            popupWrapper.style.display = "block";
            setTimeout(function () {
              $(this).hide();
                popupWrapper.classList.remove("active");
                setTimeout(function () {
                    if (!popupWrapper.classList.contains("active")) {
                        popupWrapper.style.display = "none";
                    }
                }, 10); 
            }, 1000);
        }
    }
});

        setTimeout(function () {
        $(".featured-collection-data-popup-wrapper .thumnbnail-media-position-verticle .thumbnail-list").slick({
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: !1,
                    adaptiveHeight: !1,
                    vertical: !0,
                    verticalSwiping: !0,
                    variableWidth: !1,
                    cssEase: "ease-in-out",
                    speed: 300,
                    nextArrow:
                        '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m8 10.207l3.854-3.853l-.707-.708L8 8.793L4.854 5.646l-.708.708z" clip-rule="evenodd"/></svg></button>',
                    prevArrow:
                        '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m8 5.293l3.854 3.853l-.707.708L8 6.707L4.854 9.854l-.708-.708z" clip-rule="evenodd"/></svg></button>',
                });

          }, 2000);


function handleize(text) {
    return text
        .toLowerCase()               
        .replace(/\s+/g, "-")        
        .replace(/[^a-z0-9-]/g, "")  
        .replace(/-+/g, "-")         
        .trim();                    
}

function getSelectedValue(fieldsetClass) {
    var fieldset = document.querySelector("." + fieldsetClass);
    var selectedInput = fieldset ? fieldset.querySelector("input[type='radio']:checked") : null;

    if (!selectedInput) {
        return { value: "", index: 0 }; 
    }

    var selectedValue = selectedInput.value;
    var selectedIndex = Array.from(fieldset.querySelectorAll("input[type='radio']")).indexOf(selectedInput) + 1;

    return { value: selectedValue, index: selectedIndex };
}

function getSelectedCombination() {
    var color = getSelectedValue("fieldset--value--1");
    var size = getSelectedValue("fieldset--value--2");
    var material = getSelectedValue("fieldset--value--3");

    var values = [color.value, size.value, material.value].filter(Boolean); 
    var combination = values.join(" "); 
    var handleizedCombination = handleize(combination); 

    var popups = document.querySelectorAll(".featured-collection-data-popup");
    popups.forEach(function(popup) {

        var options = popup.querySelectorAll('.product-variant-options-combination option');
        options.forEach(function(option) {
            var loopValue = option.textContent;
           
            if (loopValue === handleizedCombination) {
                var loopVarid = parseInt(option.getAttribute('data-id'));
                var loopVarImage = option.getAttribute('data-variant-image');
                
                popup.querySelector('.product-form input.product-variant-id').value = loopVarid;
            
                // Ensure this section runs when there's a valid image
                if (loopVarImage && loopVarImage !== "") {
                
                    // Update all relevant images
                    
                    popup.querySelector('.product-media-container .product__media img').srcset = loopVarImage;
                    popup.querySelector('.product-media-container .product__media img').src = loopVarImage;
                   
                    // Update thumbnail images
                    var firstThumbnailImage = popup.querySelector('media-gallery.mobile-only li.thumbnail-list__item:first-of-type button img');
                    if (firstThumbnailImage) {
                        firstThumbnailImage.srcset = loopVarImage;
                        firstThumbnailImage.src = loopVarImage;
                    }

                    // Remove aria-current from all buttons and set it on the first
                    var buttons = popup.querySelectorAll('li.thumbnail-list__item button');
                    buttons.forEach(function(button) {
                        button.removeAttribute('aria-current');
                    });

                    if (buttons.length > 0) {
                        buttons[0].setAttribute('aria-current', 'true');
                    }

                    // Update the main product media image
                    var activeMediaItemImage = popup.querySelector('media-gallery.mobile-only li.product__media-item.grid__item.is-active img');
                    if (activeMediaItemImage) {
                        activeMediaItemImage.src = loopVarImage;
                        activeMediaItemImage.srcset = loopVarImage;
                   }
                    
                }
            }
        });
    });
  
}

// Event listener for radio buttons
document.querySelectorAll("fieldset input[type='radio']").forEach(function(radioButton) {
    radioButton.addEventListener("change", function() {
        getSelectedCombination(); // Update images when the user selects a new option
    });
});

// Ensure selected combination updates when the page loads (in case of preselected values)
document.addEventListener("DOMContentLoaded", function() {
    getSelectedCombination();
});



setTimeout(function() {
    $('.product-options-wrapper').each(function() {
    if ($(this).find('p').length === 0) {
      $(this).hide(); 
    }
    });
}, 2000);
 
});

document.body.addEventListener('click', function (event) {
    if (event.target.closest('.featured-collection-data-popup-wrapper svg.icon.icon-close')) {
  setTimeout(function() {
    document.body.classList.remove('quick-view-active');
}, 1000);
        document.querySelector('.featured-collection-data-popup-wrapper').style.display = 'none';
        
    }
});

document.addEventListener("click", function (event) {
    let popupWrapper = document.querySelector(".featured-collection-data-popup-wrapper");
    if (!popupWrapper || window.getComputedStyle(popupWrapper).display === "none") {
        return; 
    }

    
    if (!popupWrapper.contains(event.target)) {
        document.body.classList.remove("quick-view-active");
        popupWrapper.style.display = "none";
      
    } else {
       
    }
});



